//FUNCIONS
import React, { useRef, useCallback, useEffect, useState } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { verifyCustomerCardIsExist, logoutCustomerCardCheckout } from '../../../../store/modules/checkout/actions';
import { StoreState } from '../../../../store/createStore';

//HOOKS
import { useCheckoutInfo } from '../../../../hooks/useCheckoutInfo';
import { useTranslation } from '../../../../hooks/useTranslation';

//TYPES
import { UserAddresses } from '../../../../store/modules/auth/types';

//COMPONENTS
import Input from '../../../../components/Input';
import Button from '../../../../components/Button';
import { AiOutlineLogout } from 'react-icons/ai';
import Loading from '../../../../components/Loading';

//STYLES
import { ContentInfoClient, ColInput, ColButton, InfoClient } from './styles';

interface handleSubmitProps {
  cpfOrEmail: string;
}

interface AddressSelectedProps {
  type: "addressUser" | "addressStore" | "addressLocker";
  id: number;
}

interface VerifyCustomerCard {
  onSetCreateCustomer: (state: number) => void;
}

const VerifyCustomerCard: React.FC<VerifyCustomerCard> = ({ onSetCreateCustomer }: VerifyCustomerCard) => {
  const { checkout: { customer: user }, loading } = useSelector((state: StoreState) => state.checkout);
  const formRef = useRef<FormHandles>(null);
  const dispatch = useDispatch();
  const [addressDefault, setAddressDefault] = useState<UserAddresses>({} as UserAddresses);
  const { onSetaddressSelect } = useCheckoutInfo();
  const { onTranslation: t } = useTranslation();

  useEffect(() => {
    if (user && user.data.customer.address) {
      if (user.data.customer.address && user.data.customer.address.length > 0) {
        user.data.customer.address.map(addresse => {
          if (addresse.selected && addresse.selected === 1)
            setAddressDefault(addresse);
          return addresse
        });
      }
    }
  }, [user]);

  const handledLogout = useCallback(() => {
    dispatch(logoutCustomerCardCheckout());
    onSetaddressSelect({} as AddressSelectedProps);
  }, [dispatch, onSetaddressSelect]);

  const handledSubmit = useCallback(
    async (data: handleSubmitProps) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          cpfOrEmail: Yup.string().required(`${t('main.messages_yup.cpf_or_email_required')}`),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await dispatch(
          verifyCustomerCardIsExist(data.cpfOrEmail, t('main.messages_toast.customer_found_sucess')),
        );
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
          //konsole.log('handleSubmit errors:', errors);
        }
      }
    },
    [dispatch, t],
  );

  const handledChangeCustomer = () => {
    onSetCreateCustomer(2);
  };

  return (
    <ContentInfoClient>
      {
        !user ? (
          <>
            <span>{t('main.view_checkout.verify_customer.search_customer')}</span>
            <Form
              ref={formRef}
              onSubmit={handledSubmit}
            >
              <ColInput>
                <Input name="cpfOrEmail" placeholder={t('main.view_checkout.verify_customer.input_cpf_email')} />
              </ColInput>

              <ColButton>
                <Button
                  button={{ type: 'submit' }}
                  atributes={{
                    buttonType: 'outline',
                    textColor: '#fff',
                    textSize: '20px',
                    borderColor: '#fff',
                    background: 'var(--primary)',
                    textColorHover: 'var(--primary)',
                    disableWitdthfixed: true,
                    borderColorHover: 'var(--primary)'
                  }}
                >
                  {loading ? (
                      <Loading color={"#fff"} size={30}/>
                  ) : (
                      <>
                        {t('main.view_checkout.verify_customer.search_register')}
                      </>
                )}
                </Button>
              </ColButton>
            </Form>
          </>
        ) : (
            <InfoClient>
              <div><span>{t('main.view_checkout.verify_customer.data_customer')}</span>
                <div>
                  <Button
                    button={{ type: 'button' }}
                    onClick={handledChangeCustomer}
                    atributes={{
                      buttonType: 'outline',
                      borderColor: 'var(--primary)',
                      textColor: '#000',
                      textSize: '16px'
                    }}
                  >
                    {t('main.globals.upgrade')}
                  </Button>
                  <Button
                    button={{ type: 'button' }}
                    onClick={handledLogout}
                    atributes={{
                      buttonType: 'outline',
                      borderColor: 'red',
                      textColor: 'red',
                      textSize: '16px'
                    }}
                  >
                    <AiOutlineLogout /> {t('main.globals.logout')}
                  </Button>
                 </div>
              </div>
              <p>{t('main.view_checkout.verify_customer.name')} {user.data.customer.first_name} {user.data.customer.last_name}</p>
              <p>{t('main.view_checkout.verify_customer.cpf')} {user.data.customer.customer_id}</p>
              <p>{t('main.view_checkout.verify_customer.date_of_birth')}  {`${user.data.customer.date_of_birth?.slice(8,10)}-${user.data.customer.date_of_birth?.slice(5,7)}-${user.data.customer.date_of_birth?.slice(0,4)}`}</p>
              <p>
                {`${t('main.view_checkout.verify_customer.address_default')} `}
                {
                  addressDefault.id > 0 ? (
                    <>
                    {addressDefault.address},{addressDefault.number} - {addressDefault.neighborhood} - {addressDefault.city} - {addressDefault.state} - CEP: {addressDefault.postcode}
                    </>
                  ) : (
                    <>
                      {t('main.view_checkout.verify_customer.not_found_address_default')}
                    </>
                  )
                }
              </p>
              <p>{t('main.view_checkout.verify_customer.phone')} {user.data.customer.phone}</p>
              <p>{t('main.view_checkout.verify_customer.email')} {user.data.customer.email}</p>
            </InfoClient>
          )
      }
    </ContentInfoClient>
  )
}

export default VerifyCustomerCard;